import { ChildModel, ModelBase } from 'store/model-base';
import { SalesChannel } from 'my-account/constants';
import { StreetAddress } from 'store/user/models';

export class OrderChannel extends ModelBase {
    public static storeName: string = 'orderChannel';
    public static idAttribute: string = 'locationId';

    public salesChannel: SalesChannel;
    public agentId: string;
    public locationId: string;
    public locationName: string;
    public locationAddress: StreetAddress;
    public isRetail: boolean;

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'locationAddress',
            model: StreetAddress
        }];
    }

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.isRetail = data.salesChannel === SalesChannel.RETAIL;

        return super.create<T>(data);
    }
}
